<template>
  <MemberSettings :super-admin="true"/>
</template>

<script>
import MemberSettings from "@/components/sites/Membersettings";

export default {
  name: "SuperAdminMemberSettings",
  components: {MemberSettings}
}
</script>

<style scoped>

</style>
